export const AVAIL_LIFETIME = 20 * 60 * 1000; // 20 min

export const PCI_URL = process.env.NODE_ENV !== 'production' ? 'https://securepre.booking-channel.com' : 'https://secure.booking-channel.com';

export const PCI_VERSION = '6';
export const PCI_VERSION_ST = 'StarTraveller';

export const SA_BOARD = '14';

export const AD_BOARD = '3';
export const AD_BOARD_BUFFET = '4';

export const PROPERTY_MANAGEMENT_GROUP = 1;

export const SERVICE_TYPE_PER_USE = 'PER USE';

export const SERVICE_TYPE_PER_STAY = 'PER STAY';

export const SERVICE_TYPE_PER_NIGHT = 'PER NIGHT';

export const SERVICE_TYPE_PER_PERSON = 'PER PERSON';

export const SERVICE_TYPE_PER_PERSON_NIGHT = 'PER PERSON PER NIGHT';

export const DISCOUNT_FLEX_RATE = 'FLEX#';

export const VALID_TPV_HASH = ['EPG:ERROR', 'EPG:OK', 'COF:OK', 'COF:ERROR', 'REDSYS:ERROR', 'REDSYS:OK', 'PAYCOMET:ERROR', 'PAYCOMET:OK', 'SIBS:ERROR', 'SIBS:OK'];

export const  AR_STATES = [
  {
    "code": "C",
    "name": "Ciudad Autónoma de Buenos Aires"
  },
  {
    "code": "B",
    "name": "Buenos Aires"
  },
  {
    "code": "K",
    "name": "Catamarca"
  },
  {
    "code": "H",
    "name": "Chaco"
  },
  {
    "code": "U",
    "name": "Chubut"
  },
  {
    "code": "X",
    "name": "Córdoba"
  },
  {
    "code": "W",
    "name": "Corrientes"
  },
  {
    "code": "E",
    "name": "Entre Ríos"
  },
  {
    "code": "P",
    "name": "Formosa"
  },
  {
    "code": "Y",
    "name": "Jujuy"
  },
  {
    "code": "L",
    "name": "La Pampa"
  },
  {
    "code": "F",
    "name": "La Rioja"
  },
  {
    "code": "M",
    "name": "Mendoza"
  },
  {
    "code": "N",
    "name": "Misiones"
  },
  {
    "code": "Q",
    "name": "Neuquén"
  },
  {
    "code": "R",
    "name": "Río Negro"
  },
  {
    "code": "A",
    "name": "Salta"
  },
  {
    "code": "J",
    "name": "San Juan"
  },
  {
    "code": "D",
    "name": "San Luis"
  },
  {
    "code": "Z",
    "name": "Santa Cruz"
  },
  {
    "code": "S",
    "name": "Santa Fe"
  },
  {
    "code": "G",
    "name": "Santiago del Estero"
  },
  {
    "code": "V",
    "name": "Tierra del Fuego"
  },
  {
    "code": "T",
    "name": "Tucumán"
  }
];

// En dispo multiHotel si se piden mas del numero establecido, no se mostrará
// el input para enviar la selección al mail ya que el link que se genera de
// dispo la mayoria de servicios de correo lo rompen ya que es muy largo
export const MULTIHOTEL_AVAIL_MODAL_LIMIT = 25;